module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "collection_location_scroll"
  }, [_c('div', {
    staticClass: "tab-pane fade in active collection_location_inner",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "name": "firstName",
      "placeholder": "First Name",
      "pattern": "^[a-zA-Z]([a-zA-Z\\s!@#]{0,24}[a-zA-Z])*$"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }, function($event) {
        _vm.capitalizeFirstName()
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "firstName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                                    Alphabets are allowed and upto 25 characters.\n                                                ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "lastName",
      "placeholder": "Last Name",
      "pattern": "^[a-zA-Z]([a-zA-Z\\s!@#]{0,24}[a-zA-Z])*$"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }, function($event) {
        _vm.capitalizeLastName()
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                                    Alphabets are allowed and upto 25 characters.\n                                                ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "email"
    },
    slot: "email"
  }, [_vm._v("Email is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.role),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("User Role Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "role"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.getRolesPermission($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select User Role Type")]), _vm._v(" "), _vm._l((_vm.roles), function(role) {
    return _c('option', {
      key: role._id,
      domProps: {
        "selected": role && _vm.user.role && role._id === _vm.user.role,
        "value": role._id
      }
    }, [_vm._v(_vm._s(role.name))])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "role",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.document1),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("User ID Proof 1")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/jpg,application/pdf",
      "id": "fileinput",
      "required": "",
      "name": "proof_1"
    },
    on: {
      "change": _vm.onDocumentchanged1
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "proof_1",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                                    Please upload less than 5mb picture\n                                                ")])]), _vm._v(" "), (
    _vm.$route.params &&
    _vm.$route.params._id != '0' &&
    _vm.user.licenceFront
  ) ? _c('div', {
    staticClass: "border p-2 mt-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.user.licenceFront,
      "target": "_blank"
    }
  }, [_vm._v("\n                                                    View\n                                                ")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.document),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("User ID Proof 2")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/jpg,application/pdf",
      "id": "fileinput1",
      "name": "proof_2"
    },
    on: {
      "change": _vm.onDocumentchanged2
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "proof_2",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                                    Please upload less than 5mb document\n                                                ")])]), _vm._v(" "), (
    _vm.$route.params &&
    _vm.$route.params._id != '0' &&
    _vm.user.licenceBack
  ) ? _c('div', {
    staticClass: "border p-2 mt-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.user.licenceBack,
      "target": "_blank"
    }
  }, [_vm._v("\n                                                    View\n                                                ")])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.mobile),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.mobile),
      expression: "user.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "maxlength": "10",
      "type": "string",
      "name": "mobile",
      "placeholder": "Contact",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.user.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "mobile",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Numbers are allowed.")])])], 1)], 1)]), _vm._v(" "), (_vm.showCityDetails) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.cityName),
      expression: "user.cityName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cityName",
      "maxlength": "25",
      "required": "",
      "placeholder": "City Name",
      "pattern": "^[a-zA-Z]([a-zA-Z\\s!@#]{0,24}[a-zA-Z])*$"
    },
    domProps: {
      "value": (_vm.user.cityName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "cityName", $event.target.value)
      }, function($event) {
        _vm.cityNameCheck()
      }]
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                                    City Name is a required field\n                                                ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                                    Alphabets/Numbers are allowed.\n                                                ")])])], 1)], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Users'
      }
    }
  }, [_c('button', {
    staticClass: "mr-2 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                    Cancel\n                                ")])]), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id == '0') ? _c('button', {
    staticClass: "btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createUser
    }
  }, [_vm._v("\n                                Save\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id != '0') ? _c('button', {
    staticClass: "btn gradientbt mr-5",
    attrs: {
      "type": "submit",
      "disabled": !((_vm.formstate.$dirty || _vm.isFileChange || _vm.isCityNameEnabled) && (_vm.formstate.$valid || _vm.isCityNameEnabled))
    },
    on: {
      "click": _vm.updateUser
    }
  }, [_vm._v("\n                                Update\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  })], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-441d32e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-441d32e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/users/UserCreate.vue
// module id = 2310
// module chunks = 0